import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PolizaSeleccionada {
  poliza_id: string;
  poliza_num: string;
}

@Component({
  selector: 'app-seleccion-poliza-dialog',
  template: `
    <h2 mat-dialog-title>Selecciona una póliza</h2>
    <mat-dialog-content>
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <button mat-raised-button color="primary" *ngFor="let poliza of data.polizas" (click)="onSelectPoliza(poliza)" style="padding: 16px 0;">
          <div style="font-size: 0.92em; margin: 8px 0; line-height: 1.2;">
            {{ poliza.detalle[0]?.marca }} - {{ poliza.detalle[0]?.patente }}
          </div>
        </button>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancelar</button>
    </mat-dialog-actions>
  `,
  standalone: false
})
export class SeleccionPolizaDialogComponent {


  constructor(
    public dialogRef: MatDialogRef<SeleccionPolizaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { polizas: any[] }
  ) {}


  onSelectPoliza(poliza: any) {
    this.dialogRef.close({
      poliza_id: poliza.poliza_id,
      poliza_num: poliza.poliza_num
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
